/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Expectlist_Planets1Inputs */

const id_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Bepergian ke dunia yang familiar, dari Tatooine ke Endor, dan seterusnya.`)
};

const ms_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Perjalanan ke dunia yang biasa, dari Tatooine ke Endor, dan seterusnya.`)
};

const da_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Rejs til velkendte verdener, fra Tatooine til Endor og videre.`)
};

const de_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Reisen Sie zu vertrauten Welten, von Tatooine bis Endor und darüber hinaus.`)
};

const en_us2_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Travel to familiar worlds, from Tatooine to Endor, and beyond.`)
};

const es_es2_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Viaja a mundos familiares, de Tatooine a Endor y más allá.`)
};

const es_mx2_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Viaja a mundos familiares, de Tatooine a Endor y más allá.`)
};

const fil_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Maglakbay sa mga pamilyar na mundo, mula Tatooine hanggang Endor, at higit pa.`)
};

const fr_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong} : Voyagez vers des mondes familiers, de Tatooine à Endor et au-delà.`)
};

const it_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Viaggia verso mondi familiari, da Tatooine a Endor e oltre.`)
};

const hu_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Utazz ismerős világokba, Tatooine-tól Endorig és azon túl.`)
};

const nl_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Reis naar bekende werelden, van Tatooine tot Endor en verder.`)
};

const no_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Reis til kjente verdener, fra Tatooine til Endor og utover.`)
};

const pl_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Podróżuj do znanych światów, od Tatooine po Endor i dalej.`)
};

const pt_br2_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Viaje para mundos familiares, de Tatooine a Endor e além.`)
};

const pt_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Viaje para mundos familiares, de Tatooine a Endor e além.`)
};

const ro_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Călătorește în lumi familiare, de la Tatooine la Endor și dincolo.`)
};

const fi_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Matkusta tuttuihin maailmoihin Tatooinesta Endoriin ja sen yli.`)
};

const sv_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Res till välbekanta världar, från Tatooine till Endor och bortom.`)
};

const vi_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Du hành đến các thế giới quen thuộc, từ Tatooine đến Endor và xa hơn nữa.`)
};

const tr_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Tatooine'den Endor'a ve ötesine kadar tanıdık dünyalara seyahat edin.`)
};

const cs_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Cestujte do známých světů, od Tatooine po Endor a dále.`)
};

const bg_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Пътувайте до познати светове, от Татуин до Ендор и отвъд.`)
};

const ru_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Путешествуйте по знакомым мирам — от Татуина до Эндора и за его пределами.`)
};

const uk_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: Подорожуйте знайомими світами від Татуїна до Ендора та далі.`)
};

const ar_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: سافر إلى عوالم مألوفة، من Tatooine إلى Endor وما وراء ذلك.`)
};

const hi_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: परिचित दुनिया की यात्रा करें।`)
};

const th_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}: เดินทางไปยังโลกที่คุ้นเคย จาก Tatooine ถึง Endor และไกลออกไป`)
};

const ja_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}：タトゥイーンからエンドアまで、おなじみの世界を旅しよう。`)
};

const zh_cn2_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🌍 ${i?.strong}：前往塔图因星到恩多星等熟悉的世界进行探索。`)
};

const zh_hant1_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}：前往塔圖因星到恩多星等熟悉的世界進行探索。`)
};

const ko_misc_posts_expectlist_planets1 = /** @type {(inputs: Misc_Posts_Expectlist_Planets1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Tatooine에서 Endor까지 익숙한 세계를 여행하세요.`)
};

/**
* | output |
* | --- |
* | "🌍 {strong}: Travel to familiar worlds, from Tatooine to Endor, and beyond." |
*
* @param {Misc_Posts_Expectlist_Planets1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_planets1 = /** @type {((inputs: Misc_Posts_Expectlist_Planets1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Planets1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_planets1(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_planets1(inputs)
	if (locale === "da") return da_misc_posts_expectlist_planets1(inputs)
	if (locale === "de") return de_misc_posts_expectlist_planets1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_planets1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_planets1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_planets1(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_planets1(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_planets1(inputs)
	if (locale === "it") return it_misc_posts_expectlist_planets1(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_planets1(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_planets1(inputs)
	if (locale === "no") return no_misc_posts_expectlist_planets1(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_planets1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_planets1(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_planets1(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_planets1(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_planets1(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_planets1(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_planets1(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_planets1(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_planets1(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_planets1(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_planets1(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_planets1(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_planets1(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_planets1(inputs)
	if (locale === "th") return th_misc_posts_expectlist_planets1(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_planets1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_planets1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_planets1(inputs)
	return ko_misc_posts_expectlist_planets1(inputs)
});
export { misc_posts_expectlist_planets1 as "misc.posts.expectList.planets" }